
import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from "react-hook-form";
import ErrorMessage from './ErrorMessage';

import "./Base64FileInput.scss";
import titleize from "underscore.string/titleize";

const Base64FileInput= ({name, prevUrl, containerSizingClass, placeholder, accept}) => {
  const { control} = useFormContext()
  const fileReader = new FileReader();

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <>
          <label className="mb-3 d-flex" htmlFor={field.name}>
            <div
              className={`upload-container ${
                field.value?.data || prevUrl ? "has-image" : ""
              }`}
              style={{
                backgroundImage: `url( ${field.value?.data || prevUrl})`
              }}
            >
              <div className={`d-flex justify-content-center align-items-center p-3 ${containerSizingClass}`}>
                <div className="upload-container-inner">
                  {field.value?.data || prevUrl
                    ? `Edit ${titleize(name)}`
                    : placeholder || "Upload Image File"}
                </div>
              </div>
            </div>
          </label>
          <input
            type="file"
            id={field.name}
            name={field.name}
            className="form-control d-none"
            accept={accept}
            onChange={
              (event) => {
                const file = event.currentTarget.files[0]
                if(!file) return
                fileReader.readAsDataURL(event.currentTarget.files[0])
                fileReader.onload = function () {
                  field.onChange({data: fileReader.result})
                };
                fileReader.onerror = function (error) {
                  console.debug('file Error: ', error);
                };
              }
            }
          />
          <ErrorMessage error={error}/>
        </>
      )}
    />
  )
}

Base64FileInput.defaultProps = {};

Base64FileInput.propTypes = {
  name: PropTypes.string.isRequired,
  prevUrl: PropTypes.string,
  containerSizingClass: PropTypes.string,
  placeholder: PropTypes.string,
  accept: PropTypes.string,
};

export default Base64FileInput;
